<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oAbrFr/tc-custom/9783987446016.jpg?1704424602237" alt="This image is the cover for the book The Cosmic Computer, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Cosmic Computer, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>An incredulous story that was possibly the inspiration for A Hitchhikers Guide to the Galaxy by Douglas Adams. Set in a post-war world, with moralising messages to emphasise the dangers of nuclear war, the book tells the story of a troupe of armed adventurers embarking on a entrepreneurial initiative. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        H. Beam Piper
      </h2>
      
      <p class="authorDescription body article">Henry Beam Piper (March 23, 1904 – c.  November 6, 1964) was an American science fiction writer. He wrote many short stories and several novels. He is best known for his extensive Terro-Human Future History series of stories and a shorter series of "Paratime" alternate history tales. He wrote under the name H. Beam Piper. Another source gives his name as "Horace Beam Piper" and a different date of death. His gravestone says "Henry Beam Piper". Piper himself may have been the source of part of the confusion; he told people the H stood for Horace, encouraging the assumption that he used the initial because he disliked his name.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?84aa4728